import React from 'react';

export default function AdminAccessDenied() {
  return (
    <div className="adm-denied" role="alert">
      <h2>You don't have access to this section.</h2>
      <p>Ask an administrator if you need it.</p>
    </div>
  );
}
